import { Title } from "@mantine/core";
import { FilterableFlows } from "../components/flows/FlowPill";

export const FlowsPage = () =>
    <>
        <Title>flows</Title>
        <FilterableFlows/>
    </>